import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import logoWhite from '@/shared/assets/img/logo-w.png'
import logoWithText from '@/shared/assets/img/logo-with-text.svg'
import cls from './logo.module.scss'

/**
 * Компонент логотипа.
 * Поддерживает разные вариации логотипа.
 */
export const Logo = React.forwardRef(function Logo(
  { variant = 'white', className, style, alt = 'Logo', ...props },
  ref,
) {
  const logoSrc = getLogoSrc(variant)

  return (
    <img
      ref={ref}
      src={logoSrc}
      alt={alt}
      className={classNames(cls.logo, className)}
      style={style}
      {...props}
    />
  )
})

/**
 * Возвращает путь к изображению логотипа в зависимости от варианта
 */
function getLogoSrc(variant) {
  switch (variant) {
    case 'white':
      return logoWhite
    case 'withText':
      return logoWithText
    default:
      return logoWhite
  }
}

Logo.propTypes = {
  /** Вариант логотипа */
  variant: PropTypes.oneOf(['white', 'withText']),
  /** Альтернативный текст для изображения */
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Logo
